import { toast } from "@/components/ui/use-toast";
import { getFormData } from "@/lib/js-helpers/getFormData";
import { WhiteLabelBrand } from "@/lib/white-label-branding/getWhiteLabelBrand";
import { FormEvent, useState } from "react";
import { useSendRequestWhiteLabelAccess } from "../api/sendRequestWhiteLabelAccess";

export function useHandleRequestAccess(
  whiteLabelBrand: WhiteLabelBrand | undefined
) {
  const [loading, setLoading] = useState(false);
  const [sendRequestAccess] = useSendRequestWhiteLabelAccess();

  function handleRequestAccess(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();

    const { email, message } = getFormData(e.currentTarget, [
      "email",
      "message"
    ] as const);

    if (!email || !whiteLabelBrand?.configID) return;

    setLoading(true);
    toast({
      title: "Sending access request"
    });

    sendRequestAccess({
      variables: {
        whiteLabelId: whiteLabelBrand.configID,
        email: email as string,
        message: (message as string) || ""
      }
    })
      .then((res) => {
        if (!res.data) return undefined;
        if (
          res.data.sendRequestWhiteLabelAccessMail.__typename === "InvalidEmail"
        )
          return toast({
            title: "Invalid email",
            description:
              "The email you have entered is invalid. Please input a valid email and try again.",
            variant: "destructive"
          });
        if (
          res.data.sendRequestWhiteLabelAccessMail.__typename ===
          "WhiteLabelConfigNotFound"
        )
          return toast({
            title: "Unable to send request",
            description:
              "An error occurred while sending the request. Please try again.",
            variant: "destructive"
          });

        return toast({
          title: "Access request sent",
          description:
            "Your request to join has been sent to the organization admin. Please wait for them to process your request.",
          duration: 1500
        });
      })
      .catch((error) => {
        console.error("sendRequestWhiteLabelAccess mutation error", error);
        toast({
          title: "Unable to send request",
          description:
            "An error occurred while sending the request. Please try again.",
          variant: "destructive"
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }

  return { handleRequestAccess, loading };
}
